import { am5, am5xy } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

import { FONT_FAMILY, FONT_SIZE } from '../../../../theme/layout-size';

const minElementsForScrollbar = 5;
export const createAxes = ({
  root,
  data,
  chart,
  yAxisField,
  xAxisField,
  rotation,
}: {
  root: am5.Root;
  chart: am5xy.XYChart;
  data: types.widgets.TableData;
  yAxisField: string;
  xAxisField: string;
  rotation: number;
}) => {
  const yRenderer = am5xy.AxisRendererY.new(root, {
    visible: false,
    minGridDistance: 10,
    inversed: true,
  });

  yRenderer.grid.template.set('visible', false);

  const yAxis = chart.yAxes.push(
    am5xy.CategoryAxis.new(root, {
      maxDeviation: 0,
      renderer: yRenderer,
      categoryField: yAxisField,
    })
  );

  yAxis.get('renderer').labels.template.setAll({
    fontSize: FONT_SIZE.xxs,
    fontFamily: FONT_FAMILY,
    textAlign: 'center',
  });

  const xRenderer = am5xy.AxisRendererX.new(root, {
    minGridDistance: 40,
  });

  xRenderer.grid.template.set('visible', false);

  const xAxis = chart.xAxes.push(
    am5xy.CategoryAxis.new(root, {
      renderer: xRenderer,
      categoryField: xAxisField,
    })
  );

  xAxis.get('renderer').labels.template.setAll({
    fontSize: FONT_SIZE.xxs,
    fontFamily: FONT_FAMILY,
    textAlign: 'center',
    rotation,
    centerY: rotation ? am5.p100 : am5.p50,
    centerX: am5.p0,
    paddingTop: 0,
    paddingBottom: 0,
    maxWidth: 100,
    oversizedBehavior: 'truncate',
  });

  const xAxisData: string[] = [];
  const yAxisData: string[] = [];
  am5.array.each(data, function (row) {
    if (yAxisData.indexOf(row[yAxisField] as string) == -1) {
      yAxisData.push(row[yAxisField] as string);
    }
    if (xAxisData.indexOf(row[xAxisField] as string) == -1) {
      xAxisData.push(row[xAxisField] as string);
    }
  });

  if (xAxisData.length > minElementsForScrollbar) {
    chart.set('scrollbarX', am5.Scrollbar.new(root, { orientation: 'horizontal' }));
  }
  if (yAxisData.length > minElementsForScrollbar) {
    chart.set('scrollbarY', am5.Scrollbar.new(root, { orientation: 'vertical' }));
  }

  yAxis.data.setAll(
    yAxisData.map(function (item) {
      return { [yAxisField]: item };
    })
  );

  xAxis.data.setAll(
    xAxisData.map(function (item) {
      return { [xAxisField]: item };
    })
  );

  return { xAxis, yAxis };
};
